var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FORM_ERROR } from 'final-form';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import RowType from '../../components/fields/RowType';
import { ErrorCode } from '../../types/types';
import { dateFromYYYYMMDD, dateToYYYYMMDD, maxDate, minDate } from '../../utils/DateUtils';
import { formatList } from '../../utils/I18nUtils';
export default function onSubmit(props, calloutContext, intl, values, form) {
    return __awaiter(this, void 0, void 0, function () {
        var newCalendar, submissionErrors, cal, e_1, response, errors;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (form.getState().hasValidationErrors) {
                        return [2 /*return*/, undefined];
                    }
                    props.setIsSubmitting(true);
                    newCalendar = {
                        id: null,
                        name: values.name,
                        startDate: values['start-date'],
                        endDate: values['end-date'],
                        assignments: [],
                        normalHours: [],
                        exceptions: []
                    };
                    (_a = values['service-points']) === null || _a === void 0 ? void 0 : _a.forEach(function (servicePoint) {
                        return newCalendar.assignments.push(servicePoint.id);
                    });
                    (_b = values['hours-of-operation']) === null || _b === void 0 ? void 0 : _b.forEach(function (opening) {
                        if (opening.type === RowType.Closed)
                            return;
                        newCalendar.normalHours.push({
                            startDay: opening.startDay,
                            startTime: opening.startTime,
                            endDay: opening.endDay,
                            endTime: opening.endTime
                        });
                    });
                    (_c = values.exceptions) === null || _c === void 0 ? void 0 : _c.forEach(function (exception) {
                        if (exception.type === RowType.Closed) {
                            newCalendar.exceptions.push({
                                name: exception.name,
                                startDate: exception.rows[0].startDate,
                                endDate: exception.rows[0].endDate,
                                openings: []
                            });
                        }
                        else {
                            // validated to not be empty as part of pre-submission
                            // therefore, we know they will all be defined and non-empty
                            // so assertion `as Date` is valid
                            var min = dateToYYYYMMDD(minDate(exception.rows
                                .filter(function (_a) {
                                var startDate = _a.startDate;
                                return startDate !== undefined;
                            })
                                .map(function (_a) {
                                var startDate = _a.startDate;
                                return dateFromYYYYMMDD(startDate);
                            })));
                            var max = dateToYYYYMMDD(maxDate(exception.rows
                                .filter(function (_a) {
                                var endDate = _a.endDate;
                                return endDate !== undefined;
                            })
                                .map(function (_a) {
                                var endDate = _a.endDate;
                                return dateFromYYYYMMDD(endDate);
                            })));
                            newCalendar.exceptions.push({
                                name: exception.name,
                                startDate: min,
                                endDate: max,
                                openings: exception.rows.map(function (row) { return ({
                                    startDate: row.startDate,
                                    startTime: row.startTime,
                                    endDate: row.endDate,
                                    endTime: row.endTime
                                }); })
                            });
                        }
                    });
                    submissionErrors = {};
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, props.submitter(newCalendar)];
                case 2:
                    cal = _d.sent();
                    props.closeParentLayer(cal.id);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _d.sent();
                    response = e_1.response;
                    return [4 /*yield*/, response.json()];
                case 4:
                    errors = (_d.sent());
                    errors.errors.forEach(function (error) {
                        switch (error.code) {
                            case ErrorCode.CALENDAR_DATE_OVERLAP:
                                calloutContext.sendCallout({
                                    message: error.message,
                                    type: 'error'
                                });
                                submissionErrors['service-points'] = (React.createElement(React.Fragment, null,
                                    React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.error.servicePointConflict", values: {
                                            list: formatList(intl, props.dataRepository.getServicePointNamesFromIds(error.data.conflictingServicePointIds)),
                                            num: props.dataRepository.getServicePointNamesFromIds(error.data.conflictingServicePointIds).length
                                        } }),
                                    ' ',
                                    error.message));
                                break;
                            case ErrorCode.CALENDAR_NO_NAME:
                            case ErrorCode.CALENDAR_INVALID_DATE_RANGE:
                            case ErrorCode.CALENDAR_INVALID_NORMAL_OPENINGS:
                            case ErrorCode.CALENDAR_INVALID_EXCEPTIONS:
                            case ErrorCode.CALENDAR_INVALID_EXCEPTION_DATE_ORDER:
                            case ErrorCode.CALENDAR_INVALID_EXCEPTION_DATE_BOUNDARY:
                            case ErrorCode.CALENDAR_INVALID_EXCEPTION_NAME:
                            case ErrorCode.CALENDAR_INVALID_EXCEPTION_OPENINGS:
                                submissionErrors[FORM_ERROR] = React.createElement(React.Fragment, null, error.message);
                                break;
                            case ErrorCode.INTERNAL_SERVER_ERROR:
                            case ErrorCode.INVALID_REQUEST:
                            case ErrorCode.INVALID_PARAMETER:
                            case ErrorCode.CALENDAR_NOT_FOUND: // not applicable
                            case ErrorCode.CALENDAR_INVALID_EXCEPTION_OPENING_BOUNDARY: // bounds are auto-generated
                            default:
                                calloutContext.sendCallout({
                                    message: (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.error.internalServerError" })),
                                    type: 'error'
                                });
                                submissionErrors[FORM_ERROR] = error.message;
                        }
                    });
                    return [3 /*break*/, 5];
                case 5:
                    props.setIsSubmitting(false);
                    return [2 /*return*/, submissionErrors];
            }
        });
    });
}
